/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Module, $) {
	'use strict';

	var SearchPromoContainer = Module.extend({
		on: function(callback) {
			callback();
		},

		after: function() {
			this.data = this.$ctx.data();
		},

		// Mark us a search-dependent module
		initSearch: function() {},

		searchConfigChanged: function(searchConfig, searchContainer) {
			if(!window.google || !window.google.ads || !window.google.ads.search || !window.google.ads.search.Ads) {
				return;
			}
			var promoBoxes = searchContainer.internalModulesByName('SearchPromoBox');
			var configs = [];
			$.each(promoBoxes, function(i, promoBox) {
				var config = promoBox.getAdConfig();
				if(config) {
					configs.push(config);
				}
			});
			if(!configs.length) {
				return;
			}
			var pageConfig = this.getPageConfig(searchConfig.query);
			try {
				window.google.ads.search.Ads(pageConfig, configs);
			} catch(e) {}
		},

		getPageConfig: function(query) {
			return {
        pubId: this.data.sitesearchSwisscomAdsenseID,
        query: query,
        hl: $('html').attr('lang') || 'de',
        adtest: 'off',
        siteLinks: false,
        oe: 'UTF-8',
        ie: 'UTF-8',
        domainLinkAboveDescription: false
			};
		}
	});

	Module.SearchPromoContainer = SearchPromoContainer;

})(window.Tc.Module, window.Tc.$);

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/sitesearch/clientlibs/logic/gui/js/modules/Tc.Module.SearchPromoContainer.js
// module id = 59
// module chunks = 0